import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import {
    ClientManagerInstanceToken,
    ClientManagerInterface,
    ConfigConstants,
    ConfigService,
    ENDPOINTS,
    HTTP_REQUEST_METHOD,
} from '@evorait/pace-core';
import { Observable } from 'rxjs';

@Injectable()
export class FormsInterceptor implements HttpInterceptor {
    public constructor(
        private readonly configService: ConfigService,
        @Inject(ClientManagerInstanceToken) private readonly clientManager: ClientManagerInterface,
    ) {}

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        if (this.isValidRequestForInterceptor(req)) {
            let scope = '';

            if (this.clientManager.isPaceUS() || this.clientManager.isPaceFormsForEvo()) {
                scope = 'P40';
            } else if (this.clientManager.isNgmP58() || this.clientManager.isPacePWA()) {
                scope = 'P58';
            } else if (this.clientManager.isNgmAP0()) {
                scope = 'AP0';
            }

            let modifiedHeaders = req.headers.set('scope', scope); // necessary for the F4M getListSet call (https://evorait.atlassian.net/browse/SHCNGMP58-140);

            if (this.isHeaderActivateCosimaRequired(req)) {
                const activateCosima = this.configService.getActivateCosima()
                    ? ConfigConstants.sapTrue
                    : ConfigConstants.sapFalse;
                modifiedHeaders = modifiedHeaders.set('ActivateCosima', activateCosima); // activate cosima forms
            }

            const clonedReq = req.clone({ headers: modifiedHeaders });

            return next.handle(clonedReq);
        }

        return next.handle(req);
    }

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    private isValidRequestForInterceptor(req: HttpRequest<any>): boolean {
        // all form requests contain the F4M keyword
        const requestUrl = req.url;
        const payload = req.body;
        return (
            requestUrl.indexOf('F4M') !== -1 ||
            (requestUrl.indexOf('DeepInsertSet') !== -1 && payload?.Endpoint.indexOf('F4M') !== -1) ||
            requestUrl.indexOf('DocBoxListSet') !== -1
        );
    }

    private isHeaderActivateCosimaRequired(request: HttpRequest<unknown>): boolean {
        return (
            request.method.toLowerCase() === HTTP_REQUEST_METHOD.GET && request.url.includes(ENDPOINTS.F4mGetListSet)
        );
    }
}
